import { render, staticRenderFns } from "./TusAsientosSGA.vue?vue&type=template&id=71639ee4"
import script from "./TusAsientosSGA.vue?vue&type=script&lang=js"
export * from "./TusAsientosSGA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports